import type { CostCenters } from "@/apis/gql/types";
import { gql, useMutation } from "@apollo/client";
import { noop } from "lodash";

import { COST_CENTERS_QUERY } from "./fetch";
export interface ICostCenterUpdate {
  costCenterIds: string[];
  updatedFields: Partial<CostCenters>;
}

export const useUpdateManyCostCenters = () => {
  const [updateManyCostCenters, { data, loading, error }] = useMutation(
    UPDATE_COST_CENTERS_MUTATION,
    {
      refetchQueries: [COST_CENTERS_QUERY],
    },
  );

  const handleUpdateManyCostCenters = async (
    data: ICostCenterUpdate,
    onSuccess: () => void = noop,
    onError: () => void = noop,
  ) => {
    await updateManyCostCenters({ variables: data });
  };

  return {
    updateManyCostCenters: handleUpdateManyCostCenters,
    data,
    loading,
    error,
  };
};

export const UPDATE_COST_CENTERS_MUTATION = gql`
  mutation updateManyCostCenters(
    $costCenterIds: [String!]!
    $updatedFields: CostCenterInput!
  ) {
    updateManyCostCenters(
      costCenterIds: $costCenterIds
      updatedFields: $updatedFields
    ) {
      costCenterId
      name
      description
      identifier
    }
  }
`;
